<div class="tw-flex tw-flex-col tw-h-full tw-text-dark-light-dynamic">
  <div class="tw-h-full" [class.mat-card-shadow]="boxShadow">
    <div
      [ngClass]="{ 'tw-hidden': !showChartOptions, 'tw-flex-col tw-relative': layoutService.isSmallScreen$ | async }"
      class="charts-actions chart-options-mobile tw-flex tw-flex-row tw-justify-between tw-mb-2 tw-flex-wrap tw-gap-y-2 tw-text-dark-light-dynamic">
      <app-option-toggle
        label="Show:"
        [options]="seriesToggleOptions"
        [selectedValue]="selectedSeries"
        [maxOptions]="3"
        (selectionChange)="onSeriesChanged($event)">
      </app-option-toggle>
    </div>
    <div class="tw-relative tw-rounded" [style.height]="getChartContainerHeight(680)">
      <!-- if this chart will have a sibling, add `tw-max-h-[500px]` -->
      <div id="highchartsContainer-{{ chartId }}" class="tw-w-full tw-h-full"></div>
    </div>
  </div>
</div>
